import React from 'react';
import { getHealthEnrollments, getDentalEnrollments } from '@utils/dashboard/processCommon';
import { ENROLLMENT_TYPES } from '@constants/individualPortal/dashboard/dashboardModelTypes';

import Enrollment from './Enrollment';
import { FormattedMessage } from 'react-intl';


const getEnrollmentGroup = (type, enrollments, applicationYear) => {
    const enrlmntType = type.toLowerCase();
    return enrollments.length
        ? enrollments.map(enrollment => (
            <Enrollment key={enrollment.id} enrollment={enrollment}/>
        ))
        : <FormattedMessage id='common.no_enrollment_type' values={{ type: <FormattedMessage id={`common.${enrlmntType}`}/>, applicationYear }}/>;
};

const EnrollmentsInfo = (props) => {
    const {
        applicationYear,
        enrollments
    } = props;

    if (!enrollments || !enrollments.length) {
        return (
            <div className={'grid-row'}>
                <FormattedMessage id='common.no_enrollments' values={{ applicationYear }}/>
            </div>
        );
    }
    const healthGroup = getHealthEnrollments(enrollments);
    const dentalGroup = getDentalEnrollments(enrollments);

    const renderHealthEnrollmentData = getEnrollmentGroup(ENROLLMENT_TYPES.HEALTH, healthGroup, applicationYear);
    const renderDentalEnrollmentData = getEnrollmentGroup(ENROLLMENT_TYPES.DENTAL, dentalGroup, applicationYear);

    return (
        <div className={'grid-row'}>
            <div className={'desktop:grid-col-6 tablet:grid-col-6 grid-col-12'}>
                { renderHealthEnrollmentData }
            </div>
            <div className={'desktop:grid-col-6 tablet:grid-col-6 grid-col-12'}>
                { renderDentalEnrollmentData }
            </div>
        </div>
    );
};


export default EnrollmentsInfo;